import React, { Component } from 'react';
import SmallLoader from './SmallLoader';

function ImageLoader({...props}){
  let loader;
  if(props.imageStatus === 'loading'){
      loader = (<SmallLoader/>);
  }
  else if(props.imageStatus === 'loaded'){
    loader = ('');
  }
  else if(props.imageStatus === 'error'){
   
    loader = (<div className="text-center">No image available</div>);

  }
  return(
    <div>
    { loader }
  </div>
  )
  
}
export default ImageLoader;


// WEBPACK FOOTER //
// ./src/components/pieces/ImageLoader.js